import React from 'react';
import AboutC from "../components/About";

const About = () => {
  
  return ( 
    <AboutC/> 
  );
}


export default About;